import { Box, styled } from '@mui/material';

const Wrapper = styled(Box)`
  display: flex;
  flex-direction: ${({ isFullScreen }) => (isFullScreen ? 'column' : 'row')};
  gap: 10px;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.6 : 1)};
`;

export default Wrapper;
